/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

const productPricingFields = `
  ndc
  name
  strength
  dgDrugName
  code
  coldShipped
  legendFee
  multiVialFee
  batchFee
  suppliesFee
  unitPrice
`;

export const listProductPricingsGql = gql`
  query listProductPricings {
    listProductPricings {
      count
      results {
        ${productPricingFields}
      }
    }
  }
`;

export const listInvoiceGroupProductPricingsGql = gql`
  query listInvoiceGroupProductPricings($invoiceGroupId: UUID!) {
    listInvoiceGroupProductPricings(invoiceGroupId: $invoiceGroupId) {
      count
      results {
        ${productPricingFields}
      }
    }
  }
`;

export const updateProductPricingsGql = gql`
  mutation updateProductPricings($productPricings: [ProductPricingInput!]!) {
    updateProductPricings(productPricings: $productPricings) {
      count
      results {
        ${productPricingFields}
      }
    }
  }
`;

export const updateInvoiceGroupProductPricingsGql = gql`
  mutation updateInvoiceGroupProductPricings(
    $invoiceGroupId: UUID!
    $productPricings: [ProductPricingInput!]!
  ) {
    updateInvoiceGroupProductPricings(
      invoiceGroupId: $invoiceGroupId
      productPricings: $productPricings
    ) {
      count
      results {
        ${productPricingFields}
      }
    }
  }
`;
